// confirmAsync — cross-platform confirmation dialog.
//
// react-native-web's Alert is a no-op (multi-button Alert.alert renders
// nothing on web), so any confirm built on Alert silently breaks in the
// browser. This helper routes to window.confirm on web and a two-button
// Alert on native, resolving a boolean either way.

import { Alert, Platform } from 'react-native';

export async function confirmAsync(opts: {
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
}): Promise<boolean> {
  const { title, message, confirmText = 'Confirm', cancelText = 'Cancel', destructive = false } = opts;

  if (Platform.OS === 'web') {
    const nativeConfirm = (globalThis as any)?.confirm;
    const text = message ? `${title}\n\n${message}` : title;
    return typeof nativeConfirm === 'function' ? !!nativeConfirm(text) : true;
  }

  return new Promise((resolve) => {
    Alert.alert(
      title,
      message,
      [
        { text: cancelText, style: 'cancel', onPress: () => resolve(false) },
        { text: confirmText, style: destructive ? 'destructive' : 'default', onPress: () => resolve(true) },
      ],
      { cancelable: true, onDismiss: () => resolve(false) },
    );
  });
}
